import React, {
  forwardRef,
  useImperativeHandle,
  useState,
  useEffect,
  useRef,
} from "react";
import {
  Table,
  Tbody,
  Tr,
  Td,
  Th,
  Thead,
  TableContainer,
  Text,
  Spinner,
  Button,
} from "@chakra-ui/react";
import axios from "axios";
import { BASE_URL } from "../../Globalapi/Globalapi";

const Print_pdf_allteachers = forwardRef(({ teachers, userId }, ref) => {
  const [teacher, setTeacher] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const printRef = useRef();

  const schoolName = sessionStorage.getItem("school_name");
  const schoolEmail = sessionStorage.getItem("school_email");
  const schoolAddress = sessionStorage.getItem("school_address");
  const schoolImage = sessionStorage.getItem("school_image_url");

  useImperativeHandle(ref, () => ({
    handlePrint,
  }));
  // Fetch Teachers function
  const fetchTeachers = async () => {
    try {
      const jwt = sessionStorage.getItem("jwt");
      const school_id = sessionStorage.getItem("school_id"); // If JWT is needed

      const response = await axios.get(
        `${BASE_URL}/admin/staff/staff_list.php?school_id=${school_id}`,
        {
          headers: {
            Authorization: `Bearer ${jwt}`,
          },
        }
      );
      setTeacher(response.data.data || []);
    } catch (error) {
      console.error("Error fetching teachers:", error);
      setError("Error fetching teachers");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTeachers();
  }, []);

  const handlePrint = () => {
    const content = printRef.current.innerHTML;
    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "none";
    document.body.appendChild(iframe);

    const iframeDoc = iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(`<div>${content}</div>`);
    iframeDoc.close();

    // Wait for the image to load before printing
    const images = iframeDoc.getElementsByTagName("img");
    const loadPromises = Array.from(images).map(
      (img) =>
        new Promise((resolve) => {
          img.onload = resolve;
          img.onerror = resolve; // Resolve on error to prevent blocking
        })
    );

    Promise.all(loadPromises).then(() => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      document.body.removeChild(iframe);
    });
  };

  const prepareTeacherData = () => {
    const formattedData = teachers.map((teacher) => ({
      id: teacher.staff_id,
      name: teacher.name,
      designation: teacher.designation,
      department: teacher.department,
      email: teacher.email,
      phone: teacher.phone,
    }));

    console.log("Prepared Teacher Data:", formattedData);
    return formattedData;
  };

  return (
    <div>
      <div
        ref={printRef}
        style={{
          padding: "20px",
          fontFamily: "Arial, sans-serif",
          lineHeight: "1.5",
        }}
      >
        {/* Header with Logo */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "40px",
            borderBottom: "1px solid #e5e5e5",
            paddingBottom: "20px",
            gap: "24px",
          }}
        >
          <img
            src={schoolImage ? `${schoolImage}` : ""}
            alt={`school Logo`}
            style={{
              width: "70px",
              height: "70px",
              objectFit: "contain",
              backgroundColor: "#fff",
              padding: "10px",
            }}
          />

          <div>
            <h1
              style={{
                margin: "0",
                fontSize: "20px",
                fontWeight: "600",
                color: "#1a1a1a",
                fontFamily: "'Times New Roman', serif",
                letterSpacing: "0.5px",
              }}
            >
              {schoolName}
            </h1>
            <h2
              style={{
                margin: "6px 0 0",
                fontSize: "18px",
                fontWeight: "500",
                color: "#666",
                fontFamily: "'Times New Roman', serif",
              }}
            >
              {schoolAddress}
            </h2>
            <p
              style={{
                fontSize: "14px",
                color: "#6C757D",
                margin: "6px 0 0",
                fontFamily: "Arial, sans-serif",
              }}
            >
              {schoolEmail}
            </p>
          </div>
        </div>
        <h3>Teachers List</h3>

        {/* Table with Teacher Data */}
        {loading ? (
          <Spinner size="xl" />
        ) : error ? (
          <Text color="red.500">{error}</Text>
        ) : (
          <TableContainer>
            <Table
              sx={{
                "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
              }}
              style={{
                border: "1px solid #d4c2c2",
                borderCollapse: "collapse",
                width: "100%",
              }}
            >
              <Thead>
                <Tr>
                  <Th style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                    Name
                  </Th>

                  <Th style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                    Email
                  </Th>
                  <Th style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                    DoB
                  </Th>
                  <Th style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                    DoJ
                  </Th>
                  {/* <Th style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                    Gender
                  </Th> */}
                  <Th style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                    Class
                  </Th>
                  <Th style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                    Division
                  </Th>
                  <Th style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                    Guardian
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {teachers.map((teacher, index) => (
                  <Tr key={index}>
                    <Td style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                      {teacher.name}
                    </Td>
                    <Td style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                      {teacher.email}
                    </Td>
                    <Td style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                      {teacher.date_of_birth}
                    </Td>
                    <Td style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                      {teacher.date_of_join}
                    </Td>
                    <Td style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                      {teacher.class}
                    </Td>
                    <Td style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                      {teacher.division}
                    </Td>

                    <Td style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                      {teacher.guardian_name}
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        )}
      </div>
    </div>
  );
});

export default Print_pdf_allteachers;
